import { Chip } from '@mui/material';
import { OrderState } from 'desk-common';

export const StateRenderer = ({ value }: { value: OrderState }) => {
  const config = {
    BORRADOR: { label: 'BORRADOR', color: 'default' },
    PENDIENTE_APROBACION_CENTRO_COSTO: {
      label: 'PENDIENTE CENTRO COSTO',
      color: 'warning',
      sx: {
        backgroundColor: '#feb820e8',
        color: '#000',
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
        fontWeight: 700,
      },
    },
    PENDIENTE_APROBACION_AREA_COMPRAS: {
      label: 'PENDIENTE ÁREA COMPRAS',
      color: 'info',
    },
    APROBADO: { label: 'APROBADO', color: 'success' },
    ANULADO_POR_AREA_COMPRAS: {
      label: 'ANULADO POR ÁREA COMPRAS',
      color: 'error',
    },
    CANCELADO_POR_USUARIO: {
      label: 'CANCELADO POR USUARIO',
      color: 'secondary',
    },
    ANULADO_POR_CENTRO_COSTO: {
      label: 'ANULADO POR CENTRO COSTO',
      color: 'error',
    },
  } as const;

  const state = config[value];

  return (
    <Chip
      label={state.label}
      color={state.color}
      size="small"
      sx={
        ('sx' in state && state.sx) || {
          fontWeight: 700,
          borderRadius: 2,
          fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
        }
      }
    />
  );
};

export const ORDER_STATE_CONFIG = {
  BORRADOR: { label: 'BORRADOR' },
  PENDIENTE_APROBACION_CENTRO_COSTO: {
    label: 'PENDIENTE CENTRO COSTO',
  },
  PENDIENTE_APROBACION_AREA_COMPRAS: { label: 'PENDIENTE ÁREA COMPRAS' },
  APROBADO: { label: 'APROBADO' },
  ANULADO_POR_AREA_COMPRAS: { label: 'ANULADO POR ÁREA COMPRAS' },
  CANCELADO_POR_USUARIO: { label: 'CANCELADO POR USUARIO' },
  ANULADO_POR_CENTRO_COSTO: { label: 'ANULADO POR CENTRO COSTO' },
} as const;
